import React, { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';

//useWarningColors means: use a color scheme indicating a warning state
//if useWarningColors is true, indicates whether to show the
// warning colors or normal colors
interface ReadOnlyNumberViewProps {
    numberContent: number | string;
    numberHeader: string;
    numberContentStyle?: CSSProperties;
    numberHeaderStyle?: CSSProperties;
    useWarningColors?: boolean;
    warningOn?: boolean;
}

const containerStyle: CSSProperties = {
    display: 'grid',
    backgroundColor: 'transparent',
    gridTemplateColumns: '1fr',
};

const defaultNumberContentStyle: CSSProperties = {
    fontSize: 20,
    fontWeight: Size.FontWeight.Regular,
    color: Color.DARK_GRAY,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

const warningOnStyle: CSSProperties = {
    ...defaultNumberContentStyle,
    color: Color.ERROR_RED,
};

const warningOffStyle: CSSProperties = {
    ...defaultNumberContentStyle,
    color: Color.VIVLI_LINK_BLUE,
};

const defaultNumberHeaderStyle: CSSProperties = {
    fontSize: 15,
    fontWeight: Size.FontWeight.ExtraBold,
    color: Color.DARK_GRAY,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
};

export const ReadOnlyNumberView = ({
    numberContent,
    numberHeader,
    numberContentStyle,
    numberHeaderStyle,
    useWarningColors,
    warningOn,
}: ReadOnlyNumberViewProps) => (
    <div style={containerStyle}>
        <div style={{ ...defaultNumberHeaderStyle, ...numberHeaderStyle }} title={numberHeader}>
            {numberHeader}
        </div>
        {useWarningColors && warningOn !== undefined && warningOn && <div style={warningOnStyle}>{numberContent}</div>}
        {useWarningColors && warningOn !== undefined && !warningOn && <div style={warningOffStyle}>{numberContent}</div>}
        {!useWarningColors && (
            <div style={{ ...defaultNumberContentStyle, ...numberContentStyle }} title={numberHeader}>
                {numberContent}
            </div>
        )}
    </div>
);
